var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-barcode"},[_c('barcode',{attrs:{"value":_vm.value,"height":_vm.theHeight,"width":_vm.theWidth}}),_vm._t("default",function(){return [_c('div',{staticClass:"has-text-centered is-uppercase is-size-6"},[_c('strong',[_vm._v(_vm._s(_vm.label))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }